@if (help) {
  <span class="link" (click)="openHelpModal(help)">help</span>
}
